import { createStyles } from "@mantine/core";
const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  btn: {
    marginLeft: "auto",
    marginTop: 50,
  },
  noteTypeNameBox: {
    background: "#fff",
    padding: "10px 20px",
    borderRadius: "10px",
    border: "1px solid #e5e5e5",
    position: "relative",
    top: "8px",
    marginBottom: "20px",
  },
  mymodal: {
    "& .mantine-Drawer-content": {
      borderRadius: "20px",
    },
    // width: 818,
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
    "& .mantine-Drawer-body": {
      // height: "100vh",
      backgroundColor: "#f5f5f5",
    },
  },
  mwd: {
    width: "100%",
  },
  myfont: {
    fontFamily: "Inter",
  },
  newFiledTtem: {
    border: "1px solid #E5E5E5",
    borderRadius: "16px",
    margin: "8px 0",
    overflow: "hidden",
    background: "#FCFCFC",
    ".mantine-Accordion-control": {
      backgroundColor: "#EAECF0",
      color: "#000",
    },
  },
  item: {
    border: "1px solid #E5E5E5",
    borderRadius: "16px",
    margin: "8px 0",
    overflow: "hidden",
    background: "#FCFCFC",
    ".mantine-Accordion-control": {
      backgroundColor: "#93370D",
      color: "#fff",
    },
  },
  exicstingFieldTtem: {
    border: "1px solid #E5E5E5",
    borderRadius: "16px",
    margin: "8px 0",
    overflow: "hidden",
    background: "#FCFCFC",
    ".mantine-Accordion-control": {
      backgroundColor: "#000",
      color: "#fff",
    },
  },
  bordered: {
    borderColor: "#00000014",
    borderRadius: 10,
    borderWidth: 1,
    borderStyle: "solid",
    padding: 20,
    marginTop: 20,
    width: "100%",
  },
  field: {
    fontFamily: "Inter",
    fontSize: 20,
    fontWeight: 600,
  },
  error: {
    color: "red",
    fontSize: "14px",
  },
}));

export default useStyles;

// import { createStyles } from "@mantine/core";
// const useStyles = createStyles((theme) => ({
//   wrapper: {
//     display: "flex"
//   },
//   content: {
//     display: "flex",
//     width: "100%",
//     flexDirection: "column"
//   },
//   btn: {
//     marginLeft: "auto",
//     marginTop: 50
//   },
//   mymodal: {
//     width: 818,
//     "& .mantine-Modal-inner": {
//       padding: "0px !important"
//     },

//   },
//   mwd: {
//     width: "100%"
//   },
//   myfont: {
//     fontFamily: "Inter"
//   },
//   bordered: {
//     borderColor: "#00000014",
//     borderRadius: 10,
//     borderWidth: 1,
//     borderStyle: "solid",
//     padding: 20,
//     marginTop: 20
//   },
//   field: {
//     fontFamily: "Inter",
//     fontSize: 20,
//     fontWeight: 600
//   },
//   error: {
//     color: "red",
//     fontSize: "14px"
//   }
// }));

// export default useStyles
